import axios from "axios";

const admin = JSON.parse(localStorage.getItem("ADMIN"));
if (admin) {
  axios.defaults.headers.common["x-access-token"] = admin.token;
}
axios.defaults.headers.common["platform"] = "AdminWeb";

export default {
  AiOnboardApi(url = `${process.env.REACT_APP_BASE_URL}/api`) {
    return {
      list: () => axios.get(`${url}/courses/ai-onboard`),
      update: (id, data) => axios.put(`${url}/courses/ai-onboard/${id}`, data),
    };
  },
};
